import { getValidAccessToken } from './tokenRefresh';
import { isAuthenticated as checkUserAuthenticated } from './userSession';

export const getAccessToken = async () => {
    // Require authentication
    if (!checkUserAuthenticated()) {
        throw new Error('User must be authenticated to get access token');
    }

    // Get user token
    const userToken = await getValidAccessToken();
    if (!userToken) {
        throw new Error('Failed to get valid access token');
    }

    return userToken;
};

/**
 * Check if user is authenticated
 * @returns {boolean} True if user is authenticated
 */
export const isAuthenticated = () => {
    return checkUserAuthenticated();
};
